<template lang="html">
	<div class="overlay-menu" :class="{abierto: menu_abierto}" @click.self="cerrar_menu">
		<div class="side-menu">
			<div class="encabezado">
				<img class="logo" :src="img" alt=""/>
			</div>
			<div class="subcontenidos scroll-light" v-if="contenidos">
				<div v-for="(contenido, index) in contenidos" :key="index" class="subcontenido">
					<div class="icono">{{contenido.tipo}}</div>
					<div class="titulo">{{contenido.nombre}}</div>
					<div class="btn btn-default" @click="lanzar(contenido)">Abrir</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import isElectron from "is-electron";
export default {
    name: "SideBarPresidencia",
    props: {
        eventBus: Object,
        logo: null,
        contenidos: Array
    },
    components: {},
    data: function() {
        return {
            menu_abierto: false
        };
    },
    computed: {
        img() {
            return require(`@/assets/img/presidencia/${this.logo}`);
        }
    },
    methods: {
        abrir_menu() {
            this.menu_abierto = true;
        },
        cerrar_menu() {
            this.menu_abierto = false;
        },
        lanzar(contenido) {
            if (isElectron()) {
                const open = require("open");
                open(contenido.ruta);
            } else {
                let win;
                switch (contenido.tipo) {
                    case "MP4":
                        this.eventBus.$emit(
                            "abrirVisorVideo",
                            "/presidencia" + contenido.ruta_web
                        );
                        break;
                    case "pdf":
                        win = window.open(
                            "/presidencia" + contenido.ruta_web,
                            "_blank"
                        );
                        win.focus();
                        break;
                    default:
                        break;
                }
            }
            console.log(contenido.ruta);
            console.log(contenido.ruta_web);
        }
    },
    created() {},
    mounted() {
        this.$globalEvent.$on("abrirMenuPresidencia", this.abrir_menu);
    }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/responsiveness.scss";
.overlay-menu {
    z-index: 9;
    position: fixed;
    width: 100%;
    height: 100%;
    right: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
    transition: visibility 0ms linear 500ms, background-color 500ms;
}

.side-menu {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 400px;
    max-width: 100%;
    height: 100%;
    // background: linear-gradient(to bottom, #002d87f1 0%, #a800c2e7 100%);
    background-color: #3d64ad;
    color: white;
    // box-shadow: 0px 0px 0px 0px black;
    transform: translateX(100%);
    transition: transform 500ms;
    display: flex;
    flex-direction: column;
}

.encabezado {
    flex-grow: 0;
}

.encabezado > .logo {
    width: 100%;
}

.subcontenidos {
    flex-grow: 1;
    overflow: auto;
    mask-image: -webkit-linear-gradient(
        top,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 20px,
        rgba(0, 0, 0, 1) calc(100% - 20px),
        rgba(0, 0, 0, 0) 100%
    );
}

.overlay-menu.abierto {
    visibility: visible;
    background-color: rgba(0, 0, 0, 0.6);
    transition-delay: 0s;
}

.overlay-menu.abierto > .side-menu {
    // box-shadow: 0px 0px 10px 0px black;
    transform: translateX(0px);
}

.subcontenido {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.6);
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    text-align: left;
}

.icono {
    background-color: white;
    color: black;
    width: 30px;
    height: 30px;
    border-radius: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
}

.titulo {
    flex-grow: 1;
}
</style>
